import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterBankList = () => {
  const bankList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-bank/list', payload, response => {
      if (response.status_code === 200) {
        const { data } = response
        callback(data)
      }
    })
  }, [])

  return { bankList }
}

export default InteractorMasterBankList
